<template lang="pug">
.card.height-100
  .card-body
    product-modal(:active="modalActive" :product="product" :link="filiationURL" @close="modalActive = false")
    .columns
      .column.col-4.col-xs-12(v-if='product.cover')
        img.img-responsive(:src='product.cover')
      .column.text-ellipsis.column-scroll
        .text-bold.text-error.text-ellipsis {{ product.title }}
        .divider
        cite {{ product.brief }}
        cite(v-if='productType')
          i(:class='productType.icon')
          |
          | {{ productType.label }}
  .card-footer
    .columns
      .column
        cite {{ product.publishDate | date("DD/MM/YYYY") }}
      .column.col-auto
        button.btn.btn-sm.btn-link.tooltip.tooltip-left.mr-2(
          data-tooltip='Qr code',
          @click='modalActive = true'
        )
          i.fas.fa-qrcode
        button.btn.btn-sm.btn-primary.tooltip.tooltip-left(
          data-tooltip='Copiar link',
          @click='copyFiliationURL'
        )
          i.fas.fa-bullhorn
</template>

<script>
import { mapState } from 'vuex'
import urlizer from '@/lib/urlizer'
import env from '@/config/env'
import ProductModal from './components/ProductModal.vue'

const mapProductTypes = {
  book: { label: 'Livro', icon: 'fas fa-book' },
  magazine: { label: 'Revista', icon: 'fas fa-book-open' },
  video: { label: 'Playlist de vídeos', icon: 'fas fa-video' },
}

export default {
  props: { product: { type: Object, required: true } },
  data() {
    return { modalActive: false }
  },
  components: { ProductModal },
  computed: {
    ...mapState('auth', ['user']),
    productType() {
      return mapProductTypes[this.product.productType]
    },
    filiationURL() {
      const url = env.storeURL
      const { id, title } = this.product
      return `${url}/store/products/${id}/${urlizer(title)}?filiation=${
        this.user.filiation.code
      }`
    },
  },
  methods: {
    async copyFiliationURL() {
      try {
        await navigator.clipboard.writeText(this.filiationURL)
        this.$toaster.success('Link copiado')
      } catch (e) {
        this.$toaster.error('Falha ao gerar link')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.column-scroll
  max-height 200px
  overflow auto
</style>
